import { Row, Col } from 'react-bootstrap';
import ArticleSection from '../../../Components/articleSection/ArticleSection';
import ArticleSubSection from '../../../Components/articleSubSection/ArticleSubSection';

import './gerdTreatments.css';

const treatments = [
  'maintaining a moderate weight, if applicable',
  'quitting smoking, if you smoke',
  'avoiding big, heavy meals in the evening',
  'waiting a few hours after eating to lie down',
  'elevating your head during sleep (by raising the head of your bed 6-8 inches)'
];

function GerdTreatments() {
  return (
    <section className="gerdTreatments">
      <Row>
        <Col md={9}>
          <ArticleSection
            heading="GERD treatment options"
            desc="To manage and relieve symptoms of GERD, your doctor might encourage you to make certain lifestyle changes, like:"
            points={treatments}
          />
          <ArticleSubSection
            heading="Medication"
            desc="Your doctor might also suggest taking over-the-counter (OTC) medications like those listed below. All of these medications can cause side effects, so talk with your doctor about which option is the best for you."
          />
          <ArticleSubSection
            heading="Antacids"
            desc="Antacids like Tums are typically used for occasional and mild symptoms of acid reflux and GERD. But if you find that you’re taking antacids almost every day, you may need a stronger medication."
          />
          <ArticleSubSection
            heading="H2 receptor blockers"
            desc="Antacids like Tums are typically used for occasional and mild symptoms of acid reflux and GERD. But if you find that you’re taking antacids almost every day, you may need a stronger medication."
          />
        </Col>
        <Col md={3}>
          <div className="add">
            <h3>Ad Space</h3>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default GerdTreatments;
